import { useQuery } from "@tanstack/react-query";
import { GetEmployeesResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useGetEmployees = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.employees(),
    queryFn: async ({ signal }): Promise<GetEmployeesResponse["employees"]> => {
      const token = await getToken();
      const response = await fetch(`/api/employees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal,
      });

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }

      const getEmployeesResponse =
        (await response.json()) as GetEmployeesResponse;
      return getEmployeesResponse.employees;
    },
    enabled: isAuthenticated,
    placeholderData: [],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
